// extracted by mini-css-extract-plugin
export var content = "Content-module--content--e838c";
export var fadeInAnimation = "Content-module--fadeInAnimation--6ca2d";
export var tags = "Content-module--tags--944ac";
export var withTags = "Content-module--withTags--6b529";
export var wrapper = "Content-module--wrapper--d34c0";